import React from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import EmailLink from '@hobs/containers/EmailLink/EmailLink';
import PrivateRoute from '@hobs/auth/components/PrivateRoute';
import NotFound from '@hobs/containers/NotFound';
import PrivateLayout from '../components/PrivateLayout';
import Home from '../containers/Home';
import Login from '../containers/Login';
import Logout from '../containers/Logout';
import Subcontractors from '../containers/Subcontractors';
import Reset from '../containers/Reset';
import AnnexOverview from '../containers/AnnexOverview';
import Party from '../containers/Party';
import Orders from '../containers/Orders';
import Order from '../containers/Order';
import RequestInformation from '../containers/RequestInformation';
import Reports from '../containers/Reports';
import { AuditLog } from '../containers/AuditLog';
import SpUpdateInfoForm from '../containers/SpUpdateInfoForm/SpUpdateInfoForm';

const Routes = () => {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route exact path="/login/:redirect?/:exerciseId?" component={Login} />
        <Route exact path="/reset/:userId/:token" component={Reset} />
        <Route exact path="/logout/:redirect?" component={Logout} />
        <Route
          exact
          path="/email-link/:redirect/:exerciseId"
          component={EmailLink}
        />
        <PrivateRoute
          layout={PrivateLayout}
          redirect="/logout"
          exact
          path="/"
          component={Home}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/subcontractors/:action?/:subcontractorId?"
          component={Subcontractors}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/annex-overview/:action?/:guid?"
          component={AnnexOverview}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/party/:action?/:guid?"
          component={Party}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/request-information/:serviceRequestId/:action?"
          component={RequestInformation}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/orders/"
          component={Orders}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/order/:orderId"
          component={Order}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/reports"
          component={Reports}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/request-information-history/:serviceRequestId/:action?"
          component={AuditLog}
        />
        <PrivateRoute
          layout={PrivateLayout}
          layoutProps={{
            withSubmenu: false
          }}
          exact
          path="/update-info/"
          component={SpUpdateInfoForm}
        />
        <Route component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
